module.exports = __webpack_public_path__ + "static/media/close-icon.44d25954.svg";